import React from 'react';


const ContentDeleted = () => {
  return (
    <div>
      <div className="container container-max">
        <div className="row">
          <div className="col-md-12 mt-3 notfound">
            <h1 className="fw-bold">Error 410 - Gone.</h1>
            <p>
              This content is no longer available and has been permanently
              removed from our publication. We regularly update our editorial
              library to keep content accurate and relevant. Continue Exploring.{" "}
              <a href="/topic/featured" className="pRed">
                Browse Latest Articles.
              </a>{" "}
              Search Topics If you believe this page was removed in error,
              please contact us.
            </p>
            <div className="mt-4 mb-4">
              <a href="/" className="pRed">
                Visit Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentDeleted;